export const ThemeConstants = {
    selector: "[data-mc-theme-name]"
}